import Checkbox from 'components/Form/Checkbox';
import FormActions from 'components/Form/FormActions';
import FormHeader from 'components/Form/FormHeader';
import FormResult from 'components/Form/FormResult';
import InputHidden from 'components/Form/InputHidden';
import SubmitButton from 'components/Form/SubmitButton';
import Stacked from 'components/Layout/Stacked';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {gettext, t} from 'ttag';
import {FormFields} from 'types/utils';
import {onApiError} from 'utils/request-axios/utils';

import {
    ProfileNotificationEditFormFields,
    usePostProfileNotificationEdit,
} from './services';
import {ProfileNotificationEditBackend} from './types';

type ProfileNotificationEditFormData =
    FormFields<ProfileNotificationEditFormFields>;

const ProfileNotificationEdit: FC = () => {
    const methods = useForm<ProfileNotificationEditFormData>();
    const {clearErrors, handleSubmit} = methods;

    const {mutateAsync} = usePostProfileNotificationEdit();

    const {
        data: {email, isNewsletterEnabled, isOnboardingEnabled, teamContext},
    } = useBackend<ProfileNotificationEditBackend>();

    const onSubmit = async (formData: ProfileNotificationEditFormData) => {
        clearErrors();
        await mutateAsync(formData).catch(onApiError(methods));
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stacked className="wrap-mail-text max-w-xl">
                    <FormHeader
                        subtitle={`${gettext('User Notifications')} - ${email}`}
                        title={t`Notification Settings`}
                    />
                    {teamContext && (
                        <InputHidden name="teamContext" value="True" />
                    )}
                    <Checkbox
                        defaultChecked={true}
                        disabled={true}
                        helpText={t`Important notifications such as password resets.`}
                        label={t`System Notifications`}
                        name="disabledDefaultSystemNotifications"
                    />
                    <Checkbox
                        defaultChecked={isNewsletterEnabled}
                        helpText={t`Roughly 1-2 emails a month.`}
                        label={t`Announcements`}
                        name="isNewsletterEnabled"
                    />
                    <Checkbox
                        defaultChecked={isOnboardingEnabled}
                        helpText={t`We occasionally send you a few emails to help you get the most out of MakeLeaps.`}
                        label={t`Onboarding, Tips, Tricks`}
                        name="isOnboardingEnabled"
                    />
                    <FormResult />
                    <FormActions align="left">
                        <SubmitButton>{t`Save`}</SubmitButton>
                    </FormActions>
                </Stacked>
            </form>
        </FormProvider>
    );
};

export default ProfileNotificationEdit;
